import { FormField, FormItem, FormMessage } from '@/components/ui/form';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { DatePickerFieldName } from '@/domain/termine/shared/types/datePicker';
import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';
import dayjs, { Dayjs } from 'dayjs';

interface DatePickerFormFieldProps {
  name: DatePickerFieldName;
  children?: (props: {
    value: Dayjs | undefined;
    onChange: (value: Dayjs | undefined) => void;
    onBlur: (value: Dayjs | undefined) => void;
    label: string;
  }) => ReactNode;
}

export function DatePickerFormField({
  name,
  children,
}: DatePickerFormFieldProps) {
  const { t } = useTranslation();
  const { form } = useCreateTermineFormContext();

  const dateValue = (fieldValue?: string | Dayjs): Dayjs | undefined =>
    fieldValue ? dayjs(fieldValue) : name === 'datum' ? dayjs() : undefined;

  const handleChange = (date: Dayjs | undefined) => {
    if (!date) {
      return;
    }
    form.setValue(name, dayjs(date).toISOString());
    form.trigger(name);
  };

  const label =
    name === 'datum'
      ? t('domain.termine.sheet.fields.am')
      : t('domain.termine.sheet.fields.laufzeitBis');

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex-1">
          {children?.({
            value: dateValue(field.value),
            onChange: handleChange,
            onBlur: field.onBlur,
            label,
          })}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
